import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import crossFetch from 'cross-fetch';
export var APOLLO_ERROR_MESSAGES;
(function (APOLLO_ERROR_MESSAGES) {
  APOLLO_ERROR_MESSAGES["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
  APOLLO_ERROR_MESSAGES["NO_RESPONSE"] = "NO_RESPONSE";
  APOLLO_ERROR_MESSAGES["UNAUTHENTICATED"] = "UNAUTHENTICATED";
  APOLLO_ERROR_MESSAGES["REQUEST_TIMED_OUT"] = "REQUEST_TIMED_OUT";
  APOLLO_ERROR_MESSAGES["NO_CONNECTION"] = "NO_CONNECTION";
})(APOLLO_ERROR_MESSAGES || (APOLLO_ERROR_MESSAGES = {}));
export var REQUEST_TIMEOUT_MS = 20000;
export var fetch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(uri, options) {
    var newOptions, controller;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            newOptions = options || {};
            if (!(newOptions !== null && newOptions !== void 0 && newOptions.signal)) {
              controller = new AbortController();
              newOptions.signal = controller.signal;
            }
            return _context.abrupt("return", crossFetch(uri, newOptions));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetch(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();